import React from "react";

import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Accordion, AccordionSummary, AccordionDetails, Stack } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { useSelector } from "react-redux";

import { global } from "../context/global";
import { faq } from "../context/faq";

export default function FAQDialog({ open, onClose }) {
    const auth = useSelector((state) => state.auth);

    if (!auth.account) {
        return null;
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth={"md"} fullWidth>
            <DialogTitle>Veelgestelde vragen (FAQ)</DialogTitle>
            <DialogContent>
                <Stack spacing={1} sx={{ mt: 1 }}>
                    {faq.map((item, index) => (
                        <Accordion key={`faq_${index}`}>
                            <AccordionSummary expandIcon={<ExpandMore />}>
                                <Typography color="primary.contrastText" variant="subtitle1" sx={{ fontWeight: "bold" }}>
                                    {item.question}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography variant="body2">
                                    {item.answer}
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{global.close}</Button>
            </DialogActions>
        </Dialog>
    );
}

